var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrop = function SvgIconCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 2.25a1 1 0 0 0-2 0V5H2.25a1 1 0 0 0 0 2H5v11a1 1 0 0 0 1 1h11v2.75a1 1 0 1 0 2 0V19h2.75a1 1 0 1 0 0-2H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6a1 1 0 0 1 1-1H18a1 1 0 0 1 1 1v8.25a1 1 0 1 1-2 0V7H9.75a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconCrop;